<div class="mb-3 flex flex-wrap lg:flex-nowrap">
  <div class="w-full">
    <div style="display: flex" class="mb-3">
      <div style="width: 260px" class="mr-2">
        <span style="font-size: 14px; font-weight: bold" class="mb-1 block"
          >Color Principal</span
        >
        <p-skeleton
          *ngIf="showSkeleton"
          shape="rectangle"
          height="2.5rem"
          width="200px"
        ></p-skeleton>
        <p-dropdown
          *ngIf="!showSkeleton"
          [options]="primaryColors"
          [(ngModel)]="selectedPrimaryColor"
          optionLabel="description"
          placeholder="Color Principal"
          class="w-full w-16 custom-dropdown"
          (onChange)="onSelectColor()"
        ></p-dropdown>
      </div>
      <div class="flex align-items-end w-full">
        <div style="flex-grow: 1; max-width: calc(100% / 4)">
          <app-color-preview
            *ngIf="!showSkeleton"
            [showSkeleton]="showSkeleton"
            [colorCode]="selectedPrimaryColor.hexValue"
          ></app-color-preview>
        </div>
        <div></div>
      </div>
    </div>
    <div style="display: flex" class="mb-3">
      <div style="width: 260px" class="mr-2">
        <span style="font-size: 14px; font-weight: bold" class="mb-1 block"
          >Colores Secundarios</span
        >
        <p-skeleton
          *ngIf="showSkeleton"
          shape="rectangle"
          height="2.5rem"
          width="200px"
        ></p-skeleton>
        <p-dropdown
          *ngIf="!showSkeleton"
          [options]="secondaryColors"
          [(ngModel)]="selectedSecondaryColor"
          optionLabel="desc"
          placeholder="Colores Secundarios"
          class="w-full w-16 custom-dropdown"
          (onChange)="onSelectColor()"
        ></p-dropdown>
      </div>
      <div *ngIf="!showSkeleton" class="flex align-items-end w-full">
        <div
          *ngFor="let color of selectedSecondaryColor.hex"
          style="flex-grow: 1; max-width: calc(100% / 4)"
        >
          <app-color-preview
            [showSkeleton]="showSkeleton"
            [colorCode]="color"
          ></app-color-preview>
        </div>
      </div>
    </div>
  </div>

  <div
    class="w-full"
    [ngStyle]="{ backgroundColor: this.selectedSecondaryColor.hex[0] }"
  >
    <app-casino-preview
      *ngIf="!showSkeleton"
      [colors]="colorSchema"
    ></app-casino-preview>
    <p-skeleton
      *ngIf="showSkeleton"
      shape="rectangle"
      height="100%"
      width="100%"
    ></p-skeleton>
  </div>
</div>

<!-- dialog -->
<p-dialog
  [(visible)]="showConfirmDialog"
  [modal]="true"
  [dismissableMask]="true"
  [style]="{ width: '500px' }"
  appendTo="body"
  [draggable]="false"
  (onHide)="closeConfirmDialog()"
>
  <p-header>
    <div class="flex justify-content-start flex-row align-content-start">
      <i
        class="pi pi-exclamation-triangle"
        style="font-size: 2rem; padding-top: 5px"
      ></i>
      <label class="header_title">Confirmar Cambios</label>
    </div>
  </p-header>
  <p>
    Al confirmar esta ventana, el
    <strong>Tema de Colores de tu Casino</strong> será actualizado. <br />
    El cambio será aplicado para <strong>todos tus Players.</strong>
    <span class="mt-3 block">Deseas continuar?</span>
  </p>

  <p-footer>
    <div *ngIf="!showProgress" style="display: flex; justify-content: right">
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-times"
        class="p-button-rounded p-button-text"
        label="Cancelar"
        (click)="showConfirmDialog = false"
      ></button>
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-check"
        class="p-button-rounded p-button-text"
        label="Confirmar"
        (click)="applyTheme()"
      ></button>
    </div>
    <p-progressBar
      *ngIf="showProgress"
      mode="indeterminate"
      [style]="{ height: '4px' }"
    ></p-progressBar>
  </p-footer>
</p-dialog>
